export enum HeaderName {
  Accept = "accept",
  TenantName = "x-tenant-name",
  RememberMe = "X-Remember-Me",
  Authorization = "Authorization",
}

export interface OperationContext {
  isUserVisitor?: boolean,
  shouldUseAuthSchema?: boolean,
  rememberMeToken?: string,
  shouldNotShowErrorIfUnauthorized?: boolean,
}

export interface OperationHeaders {
  [HeaderName.Accept]: "application/json",
  [HeaderName.TenantName]?: string,
  [HeaderName.RememberMe]?: string,
  [HeaderName.Authorization]?: string,
}
